import React, { useState } from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import TableFunction from '../../../../../components/table/TableFunction';
import dayId from '../../../../../hooks/dayId';
import {TrashOutlineIcon} from '../../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../../components/buttons/ButtonAction';

const WorkShiftTable = ({ data, view, isCustomized = false }) => {

    const [tableId, setTableId] = useState("tbl_awst_table");
    const [searchId, setSearchId] = useState("tbl_awst_search_id");

    const getThead = () => {
        let header = [
            <CustomTh tableId={tableId} classes="first_head">{t('zones')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('day')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('from')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('to')}</CustomTh>
        ];
        return header;
    }

    const getTbody = () => {
        if(!data || data?.length === 0) return {
            body: [],
            data: []
        };
        let body = data?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} classes={"first-column"} >{item?.zoneName || '-'}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.dayId ? dayId(item?.dayId) : '-'}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.from || '-'}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.to || '-'}</CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: data
        }
    };

    const { t, thead, tbody, pagination, page, setPage, rowsPerPage, setRowsPerPage } = TableFunction({
        data,
        getThead,
        getTbody,
        labelRowsPerPage: 'accesses_per_page',
        fixedPagination: false,
        view: view
    });

    return {
        tableId,
        searchId,
        thead,
        tbody,
        pagination, page, setPage, rowsPerPage, setRowsPerPage
    };

}
export default WorkShiftTable;
